module.exports = "/assets/js/56a1374bda792cf6df6fd1d278bdcc9f.svg";